<script>
import {
  computed,
} from 'vue';

import Table from './Table.vue';

import useSectionState from '@/state/useSectionState';
import useMainState from '@/state/useMainState';

// Directives
import scrollReveal from '@/directives/scroll-reveal';

export default {
  components: {
    Table,
  },
  directives: {
    scrollReveal,
  },
  setup() {
    const {
      sectionTables,
      isBreakdownOverviewSection,
      getTableById,
      sectionMetrics,
    } = useSectionState();

    const { isOverview } = useMainState();

    const tables = computed(() => sectionTables.value.filter((table) => {
      if (!table.valid) {
        return false;
      }

      const isBreakdownTable = table.type === 'breakdown';
      const isSummaryTable = table.type === 'summary';

      // breakdown view, only show breakdown table
      if (isBreakdownOverviewSection.value) {
        return isBreakdownTable;
      }

      // default view, show summary only when more than one metric
      if (isSummaryTable && sectionMetrics.value.length < 2) {
        return true;
      }

      // rest of the tables
      return !isBreakdownTable && !isSummaryTable;
    }));

    const updateTable = (id, value) => {
      getTableById(id).getExportData = value;
    };

    const changeInterval = (id, value) => {
      getTableById(id).selectedInterval = value;
    };

    return {
      tables,
      isOverview,
      updateTable,
      changeInterval,
    };
  },
};
</script>

<template>
  <div
    class="w-full flex flex-col gap-8"
  >
    <Table
      v-for="(table, i) in tables"
      :key="`${table.title}_${table.type}_${i}`"
      v-scroll-reveal
      data-testid="table"
      :table="table"
      @update="(value) => updateTable(table.id, value)"
      @change-interval="(value) => changeInterval(table.id, value)"
    />
  </div>
</template>
